window.LiveDeals = {
    init() {
        this.bindInterestDealBtn();
        this.handleAnalytics();
    },

    bindInterestDealBtn() {
        $('.interest-deal-btn').click((event) => {
            $('.interest-deal-btn').addClass('disabled');
        })
    },

    handleAnalytics() {
        document.addEventListener('analyticsReady', () => {
            const expressInterestBtns = document.querySelectorAll('.interest-deal-btn');
            expressInterestBtns.forEach(expressInterestBtn => {
                expressInterestBtn.addEventListener('click', () => {
                    const userId = document.getElementById('user_id').value;
                    const companyId = document.getElementById('company_id').value;
                    const dealId = document.getElementById('deal_id').value;
                    analytics.track(ANALYTICS_EVENTS.DEAL_EOI_CLICKED, {
                        user_id: userId,
                        company_id: companyId,
                        deal_id: dealId
                    })
                })
            });
        });
    }
}

window.DealCentre = {
    init() {
        this.handleAnalytics();
    },

    handleAnalytics() {
        document.addEventListener('analyticsReady', () => {
            const userId = document.getElementById('user_id').value;
            const companyId = document.getElementById('company_id').value;

            analytics.page("", ANALYTICS_EVENTS.DEAL_CENTER_PAGE_VIEWED, {
                user_id: userId,
                company_id: companyId
            });

            const eoiSignupBtn = document.getElementById('deal-interest-sign-up-btn');
            if (eoiSignupBtn) {
                eoiSignupBtn.addEventListener('click', () => {
                    analytics.track(ANALYTICS_EVENTS.DEAL_EOI_SIGN_UP_CLICKED, {
                        user_id: userId,
                        company_id: companyId
                    })
                })
            }
        });
    }
}

window.DealDetails = {
    init() {
        this.handleAnalytics();
        this.handleUpdateUsers();
    },

    handleUpdateUsers() {
        $('#update_collaborators').on('click', function () {
            console.log('clicked');
            let user_ids = $('#user_ids_').val();
            let deal_uuid = $('#deal_uuid').val();
            $.ajax({
                url: `/deals/${deal_uuid}/deal_users`,
                type: 'POST',
                data: {'user_ids': user_ids},
                dataType: 'json',
                async: false,
                success: function () {
                    window.location.reload();
                },
                error: function () {
                    window.location.reload();
                }
            });
        });
    },

    handleAnalytics() {
        document.addEventListener('analyticsReady', () => {
            const userId = document.getElementById('user_id').value;
            const companyId = document.getElementById('company_id').value;
            const dealId = document.getElementById('deal_id').value;
            analytics.page("", ANALYTICS_EVENTS.DEAL_DETAILS_PAGE_VIEWED, {
                user_id: userId,
                company_id: companyId,
                deal_id: dealId
            });

            const translateBtn = document.querySelector('.translate-button');
            if (translateBtn) {
                translateBtn.addEventListener('click', () => {
                    analytics.track(ANALYTICS_EVENTS.DEAL_DETAILS_TRANSLATE_CLICKED, {
                        user_id: userId,
                        company_id: companyId,
                        deal_id: dealId,
                        to_language: document.getElementById('locale').value
                    })
                });
            }


        });
    }
}
